// extracted by mini-css-extract-plugin
module.exports = {"scroll":"ScrollView_scroll__19nI6","marginMedium":"ScrollView_marginMedium__2gott","marginSmall":"ScrollView_marginSmall__3RunB"};